import { combineReducers } from 'redux'

import activeSession from '~/reducers/active-session'
import app from '~/reducers/app'
import calendar from '~/reducers/calendar'
import ui from '~/reducers/ui'
import events from '~/reducers/events'
import room from '~/reducers/room'
import roomSettings from '~/reducers/room-settings'
import settings from '~/reducers/settings'
import recents from '~/reducers/recents'
import featureFlags from '~/reducers/feature-flags'
import salesforce from '~/reducers/salesforce'
import screenshots from '~/reducers/screenshots'
import sharedFiles from '~/reducers/shared-files'

const reducer = combineReducers({
  app,
  calendar,
  ui,
  events,
  room,
  recents,
  activeSession,
  roomSettings,
  salesforce,
  settings,
  featureFlags,
  screenshots,
  sharedFiles
})

export default (state, action) => {
  if (action.type === 'RESET_APP') {
    return reducer(undefined, action)
  }

  return reducer(state, action)
}
